// extracted by mini-css-extract-plugin
export default {"quotes":"Quotes_quotes__Sfe0d","paragraph":"Quotes_paragraph__fto7I","sorting":"Quotes_sorting__fP+nJ"};